/**
 * TransferCheckbox - Subdued checkbox for transfer checklists.
 *
 * Smaller and more muted than the default primary-colored checkbox.
 * Uses zinc-700 checked state instead of the loud purple primary.
 */

import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';

interface TransferCheckboxProps {
  checked: boolean;
  onToggle: () => void;
  className?: string;
}

export const TransferCheckbox: React.FC<TransferCheckboxProps> = ({
  checked,
  onToggle,
  className,
}) => (
  <Checkbox
    checked={checked}
    onCheckedChange={onToggle}
    className={cn(
      'size-4 rounded border-gray-400 shadow-none',
      'data-[state=checked]:bg-zinc-700 data-[state=checked]:border-zinc-700 data-[state=checked]:text-white',
      className,
    )}
  />
);
